(function() {
    window.userManagementService = {
        get() {
            return axios.get('/api/users/get.php');
        },
        save(data){
          return axios.post('/api/users/save.php', data);
        }
    }
  })();